export default "__VITE_ASSET__DqOJC3XH__"